import { render, staticRenderFns } from "./addressDetail.vue?vue&type=template&id=2113254e&scoped=true"
import script from "./addressDetail.vue?vue&type=script&lang=js"
export * from "./addressDetail.vue?vue&type=script&lang=js"
import style0 from "./addressDetail.vue?vue&type=style&index=0&id=2113254e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2113254e",
  null
  
)

export default component.exports